var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import WixComponent from '../../BaseComponents/WixComponent';
import TextLinkLayout from '../../BaseComponents/TextLinkLayout';

var BaseTextLink = function (_WixComponent) {
  _inherits(BaseTextLink, _WixComponent);

  function BaseTextLink() {
    _classCallCheck(this, BaseTextLink);

    return _possibleConstructorReturn(this, (BaseTextLink.__proto__ || Object.getPrototypeOf(BaseTextLink)).apply(this, arguments));
  }

  _createClass(BaseTextLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ariaLabel = _props.ariaLabel,
          disabled = _props.disabled,
          link = _props.link,
          children = _props.children,
          download = _props.download,
          rel = _props.rel,
          target = _props.target,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave;

      var props = {
        download: download,
        href: '' + link,
        onClick: function onClick(event) {
          return disabled && event.preventDefault();
        },
        role: 'link',
        style: {
          textDecoration: 'inherit',
          color: this.props.color ? this.props.color : 'inherit',
          tabIndex: 0
        }
      };

      if (ariaLabel) {
        props['aria-label'] = ariaLabel;
      }

      if (rel) {
        props.rel = rel;
      }

      if (target) {
        props.target = target;
      }

      if (onMouseEnter) {
        props.onMouseEnter = onMouseEnter;
      }

      if (onMouseLeave) {
        props.onMouseLeave = onMouseLeave;
      }

      return React.createElement(
        TextLinkLayout,
        this.props,
        React.createElement(
          'a',
          props,
          children
        )
      );
    }
  }]);

  return BaseTextLink;
}(WixComponent);

BaseTextLink.propTypes = Object.assign({}, TextLinkLayout.propTypes, {
  link: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  download: PropTypes.bool,
  rel: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_parent', '_self', '_top', 'framename']),
  ariaLabel: PropTypes.string,
  color: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
});
BaseTextLink.defaultProps = Object.assign({}, TextLinkLayout.defaultProps, {
  disabled: false,
  download: false,
  rel: null,
  target: null
});
export default BaseTextLink;
//# sourceMappingURL=TextLink.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/BaseComponents/TextLink/TextLink.js